import AppHeader from "@/components/AppHeader";

export default {
  name: "master-car-edit",
  components: {
    AppHeader
  },
  async created() {
    this.getCompany();
    await this.getCar();
    this.getDepartment();
  },
  data() {
    return {
      car: {
        company_id: "",
        department_id: "",
        priority: "",
        car_number: "",
        name: "",
        is_forward_hide: 0
      },
      companies: "",
      getCompaniesEnd: false,
      getCarEnd: false,
      getDepartmentsEnd: false
    };
  },
  methods: {
    async getCompany() {
      let data = {};
      let res = await this.$store
        .dispatch("GET_COMPANY", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.companies = res.companies;
      this.getCompaniesEnd = true;
    },
    async getDepartment() {
      this.getDepartmentsEnd = false;
      let data = {
        company_id: this.car.company_id
      };
      let res = await this.$store
        .dispatch("GET_DEPARTMENT", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.departments = res.departments;
      this.getDepartmentsEnd = true;
    },
    async getCar() {
      let data = {};
      let res = await this.$store
        .dispatch("SHOW_CAR", {
          id: this.$route.params.car_id,
          data: data
        })
        .catch(err => {
          console.log(err);
          return;
        });

      this.car.company_id = res.car.company_id;
      this.car.deparment_id = res.car.department_id;
      this.car.priority = res.car.priority;
      this.car.car_number = res.car.car_number;
      this.car.name = res.car.name;
      this.car.is_forward_hide = res.car.is_forward_hide;
      this.getCarEnd = true;
    },
    async editCar() {
      let data = this.car;
      let res = await this.$store
        .dispatch("EDIT_CAR", {
          id: this.$route.params.car_id,
          data: data
        })
        .catch(err => {
          console.log(err);
          return;
        });
      if (res.error) {
        this.errorInfo = res.error;
      } else {
        this.$router.push({ path: "/master_car" });
      }
    },
    changeCompany() {
      this.car.deparment_id = "";
      this.getDepartment();
    },
    goMasterCar() {
      this.$router.push({ path: "/master_car" });
    }
  }
};
